module.exports = {
    assemble:{
        我的:'我的',
        积分商城:'积分商城',
        消息:'消息',
        提醒:'提醒',
        退出:'退出',
        客户管理:'客户管理',
        我的积分:'我的积分',
        个人资料:'个人资料',
        查看详情:'查看详情',
        我的客户:'我的客户',
        报备:'报备',
        导入:'导入',
        导出:'导出',
        搜索:'搜索',
        清空:'清空',
        全选:'全选',
        全不选:'全不选',
        已选删除:'已选删除',
        已选彻底删除:'已选彻底删除',

        客户头像:'客户头像',
        客户名字:'客户名字',
        联系电话:'联系电话',
        项目:'项目',
        状态:'状态',
        操作:'操作',

        全部:'全部',
        已联系没兴趣:'已联系,没兴趣',
        正在沟通中:'正在沟通中',
        已完成:'已完成',
        介绍费已到账:'介绍费已到账',

        详情:'详情',
        编辑:'编辑',
        删除:'删除',
        完成:'完成',


        名:'名',
        姓:'姓',
        电话号码:'电话号码',
        城市:'城市',
        邮箱:'邮箱',


        确认:'确认',
        取消:'取消',

        客户信息:'客户信息',
        添加新用户:'添加新用户',
        跟进进度:'跟进进度',
        更改详情:'更改详情',
        确定删除:'您确定要删除该客户吗？',

        
        商品兑换记录:'商品兑换记录',
        代金券兑换记录:'代金券兑换记录',
        现金兑换记录:'现金兑换记录',

        共计:'共计',
        积分兑换:'积分兑换',
        积分数量:'积分数量',
        到账时间:'到账时间',
        返回:'返回',

        商品图片:'商品图片',
        商品名称:'商品名称',
        兑换金额:'兑换金额',
        状态:'状态',
        类型:'类型',
        兑换时间:'兑换时间',


        已使用:'已使用',
        未使用:'未使用',
        积分:'积分',
        代金券:'代金券',


        代金券名称:'代金券名称',
        代金券面值:'代金券面值',
        使用状态:'使用状态',
        代金券码:'代金券码',

        
        转账方式:'转账方式',
        真实姓名:'真实姓名',

        个人资料:'个人资料',
        基本信息:'基本信息',
        编辑用户信息:'编辑用户信息',
        头像:'头像',
        限图片:'限图片',
        以内:'以内',

        用户名:'用户名',
        手机号:'手机号',
        密码:'密码',
        修改:'修改',

        兑换商品:'兑换商品',
        请选择兑换类型:'请选择兑换类型',
        兑换价格:'兑换价格',
        剩余金额:'剩余金额',
        立即兑换:'立即兑换',
        比例金额:'比例金额',
        现金兑换:'现金兑换',

        确定:'确定',
        剩余积分:'剩余积分',
        描述:'兑换代金券，会有额外10%的bonus，代金券可以用于我们的网上商城，冷暖气购买，安装以及维修服务（代金券不能跨店使用，只能用于大多地区的恒致冷暖）',
        代金券兑换:'代金券兑换',
        可兑换代金券:'可兑换代金券',
        购买:'购买',


        修改密码:'修改密码',
        手机号:'手机号',
 
        新密码:'新密码',
        确认密码:'确认密码',
        兑换成功:'您已兑换成功，兑换链接将会发送到您邮箱中，请注意查收',

        提示:'提示',
        确定兑换代金券:'您确定要兑换该代金券吗?',

        支票:'支票',
        EMT转账:'EMT转账',

        发送验证码:'发送验证码',
        输入新密码和确认新密码需要一致:'输入新密码和确认新密码需要一致',

        排序:'排序',

        登录:'登录',
        手机号登录:'手机号',
        邮箱登录:'邮箱',
        密码:'密码',
        自动登录:'自动登录',
        验证码登录:'验证码登录',
        注册账号:'注册账号',
        忘记密码:'忘记密码',
        发送验证码:'发送验证码',
        账号登录:'账号登录',


        注册:'注册',
        用户名:'用户名',
        密码:'密码',

        忘记密码:'忘记密码',
        新密码:'新密码',
        确认新密码:'确认新密码',


        客户名称:'客户名称',

        请输入手机号:"请输入手机号",
        请输入邮箱地址:"请输入邮箱地址",
        请输入密码:"请输入密码",
        验证码:"验证码",
        请输入验证码:"请输入验证码",
        请输入用户名:"请输入用户名",
        请输入新密码:"请输入新密码",
        输入新密码和确认新密码需要一致:"输入新密码和确认新密码需要一致",

        开始日期:"开始日期",
        结束日期:"结束日期",
        至:"至",
        请输入手机号:"请输入手机号",
        请输入邮箱地址:"请输入邮箱地址",
        请输入手机号内的验证码:"请输入手机号内的验证码",
        请输入验证码:"请输入验证码",
        请输入邮箱内的验证码:"请输入邮箱内的验证码",
        请输入确认密码:"请输入确认密码",

        邮箱地址:'地址',
    }
}